import {z} from "zod";

export const revokeHouseholdOccupantSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(10, "Reason must be at least 10 characters")
    .max(1000, "Reason must be 1000 characters or less"),
});

export type RevokeHouseholdOccupantInput = z.infer<typeof revokeHouseholdOccupantSchema>;
